import React from 'react';
import { Paper, Box, Tabs, Tab, Typography } from '@mui/material';
import TabPanel from '../../components/common/tabs/TabPanel';
import TechReqFormContainer from './TechReqFormContainer';
import TechFileListContainer from '../techmng/support/TechFileListContainer';
import TechReqView from '../../components/techmng/support/TechReqView';
import TechPlanAddFormContainer from './TechPlanAddFormContainer';
import TechPlanFormContainer from './TechPlanFormContainer';
import TechPlanView from '../../components/techmng/support/TechPlanView';
import TechRsltAddContainer from './TechRsltAddContainer';
import TechRsltEditContainer from './TechRsltEditContainer';
import TechRsltView from '../../components/techmng/support/TechRsltView';
import TechMidAddFormContainer from './TechMidAddFormContainer';
import TechMidsViewContainer from './TechMidsViewContainer';


function a11yProps(index) {
    return {
        id: `tech-tab-${index}`,
        'aria-controls': `tech-tabpanel-${index}`,
    };
}

const TechThirdStepContainer = ({ activeTap, handleTabChange, reloadTech, tech, techPlan, techMids, techMidInfo, techRslt, project, user }) => {

    return (
        <Paper
            sx={{
                mt: 1,
                pb: 1,
            }}
        >
            <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTap}
                    onChange={handleTabChange}
                    aria-label="기술 지원 관리"
                >
                    <Tab label="지원요청" {...a11yProps(0)} />
                    <Tab label="작업계획" {...a11yProps(1)} />
                    <Tab label={
                        <React.Fragment>
                            <Typography variant="subtitle2" component="div">
                                중간보고
                            </Typography>
                            <Typography variant="caption" component="div">
                                (7일 이상 시행)
                            </Typography>
                        </React.Fragment>
                    } {...a11yProps(2)} />
                    <Tab label="완료보고" {...a11yProps(3)} />
                    <Tab label="파일 리스트" {...a11yProps(4)} />
                </Tabs>
            </Box>
            <TabPanel value={activeTap} index={0}>
                {(user.usrUuid === tech?.crtUsr && Number(tech.reqGrade) < 4) ? (
                    <TechReqFormContainer project={project} tech={tech} user={user} />
                ) : (<TechReqView tech={tech} />)}
            </TabPanel>
            <TabPanel value={activeTap} index={1}>
                {(tech?.planUuid === null || tech?.planUuid === '') ? (<TechPlanAddFormContainer project={project} tech={tech} user={user} reloadTech={reloadTech} />)
                    : (user.usrUuid === techPlan?.crtUsr && Number(tech.reqGrade) < 4) ? (
                        <TechPlanFormContainer project={project} tech={tech} techPlan={techPlan} user={user} reloadTech={reloadTech} />
                    ) : (<TechPlanView tech={tech} techPlan={techPlan} />)}
            </TabPanel>
            <TabPanel value={activeTap} index={2}>
                {techPlan && !techPlan?.plnTyp.includes('장기') ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="subtitle2">작업 계획 종류가 프로젝트(장기)5일 이상일 경우 등록합니다.</Typography>
                    </Box>
                ) : (<Box>
                    {Number(tech.reqGrade) < 4 && (
                        <TechMidAddFormContainer project={project} tech={tech} user={user} reloadTech={reloadTech} />
                    )}
                    <TechMidsViewContainer tech={tech} techMids={techMids} user={user} />
                </Box>)}
            </TabPanel>
            <TabPanel value={activeTap} index={3}>
                {(tech?.rsltUuid === null || tech?.rsltUuid === '') ?
                    (<TechRsltAddContainer project={project} tech={tech} techPlan={techPlan} techMidInfo={techMidInfo} user={user} reloadTech={reloadTech} />)
                    : (user.usrUuid === techRslt?.crtUsr && Number(tech.reqGrade) <= 4) ? (
                        <TechRsltEditContainer tech={tech} techPlan={techPlan} techMidInfo={techMidInfo} techRslt={techRslt} user={user} reloadTech={reloadTech} />
                    ) : (<TechRsltView tech={tech} techPlan={techPlan} />)}
            </TabPanel>


            <TabPanel value={activeTap} index={4}>
                <TechFileListContainer tech={tech} />
            </TabPanel>

            <Box sx={{ width: '100%', borderTop: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTap}
                    onChange={handleTabChange}
                    aria-label="기술 지원 관리"
                    TabIndicatorProps={{ style: { top: 0 } }}
                >
                    <Tab label="지원요청" {...a11yProps(0)} />
                    <Tab label="작업계획" {...a11yProps(1)} />
                    <Tab label={
                        <React.Fragment>
                            <Typography variant="subtitle2" component="div">
                                중간보고
                            </Typography>
                            <Typography variant="caption" component="div">
                                (7일 이상 시행)
                            </Typography>
                        </React.Fragment>
                    } {...a11yProps(2)} />
                    <Tab label="완료보고" {...a11yProps(3)} />
                    <Tab label="파일 리스트" {...a11yProps(4)} />
                </Tabs>
            </Box>

        </Paper>
    );
};


export default TechThirdStepContainer;
